import logger from './log'

const TOKEN_REFRESH_FALLBACK_MS = 60000
const TOKEN_SAFETY_WINDOW_MS = 60000

const scheduleTokenRefresh = (delayMs = TOKEN_REFRESH_FALLBACK_MS) => {
  setTimeout(async () => {
    try {
      const refreshed = await window?.dd?.auth.updateToken(30)
      const expiresAtSeconds = window?.dd?.auth.getToken()?.expiresAt ?? 0
      const expiresInMs = expiresAtSeconds * 1000 - Date.now()
      const safeExpiresInMs = Math.max(expiresInMs, 0)
      const nextDelay =
        safeExpiresInMs > TOKEN_SAFETY_WINDOW_MS ? safeExpiresInMs - TOKEN_SAFETY_WINDOW_MS : TOKEN_REFRESH_FALLBACK_MS
      console.log(refreshed ? 'Token was refreshed' : 'Token is still valid')
      console.log(`Next token refresh scheduled in ${nextDelay / 1000} seconds`)
      scheduleTokenRefresh(nextDelay)
    } catch (error) {
      logger.error('Failed to refresh token', error)
      const tokenExpiresAt = (window?.dd?.auth.getToken()?.expiresAt ?? 0) * 1000
      if (tokenExpiresAt <= Date.now()) {
        window?.keycloak?.login()
        return
      }
      scheduleTokenRefresh(TOKEN_REFRESH_FALLBACK_MS)
    }
  }, delayMs)
}

export default scheduleTokenRefresh
